import Routes from "routing/Routes";
export const PAGE_NAV_TITLE = "Sidecar";
const bindings = {
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      children: [
        { description: "Overview", titleKey: "navigation:page_navigation.overview", path: Routes.SYSTEM.SIDECARS.OVERVIEW, exactPathMatch: true },
        { description: "Administration", titleKey: "navigation:page_navigation.administration", path: Routes.SYSTEM.SIDECARS.ADMINISTRATION },
        { description: "Configuration", titleKey: "navigation:page_navigation.configuration", path: Routes.SYSTEM.SIDECARS.CONFIGURATION },
        { description: "Failure Tracking", titleKey: "navigation:page_navigation.failure_tracking", path: Routes.SYSTEM.SIDECARS.FAILURE_TRACKING }
      ]
    }
  ]
};
export default bindings;
